import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = 'oldPages/user-management/index.html';

const links: Record<string, string> = {
  users: '/infoTrac/user-management',
  roles: '/infoTrac/user-management/roles',
  singleUser: '/infoTrac/user-management/single-user',
  createNewUser: '/infoTrac/user-management/create-user',
  apps: '/infoTrac/user-management/apps',
};

function UserManagement() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const users = iframeDocument.getElementById('users');
      const roles = iframeDocument.getElementById('roles');
      const apps = iframeDocument.getElementById('apps');

      const createNew = iframeDocument.getElementById('createNewUser');

      if (users) users.addEventListener('click', () => navigate(links.users));
      if (roles) roles.addEventListener('click', () => navigate(links.roles));
      if (apps) apps.addEventListener('click', () => navigate(links.apps));

      if (createNew) createNew.addEventListener('click', () => navigate(links.createNewUser));

      const singleUser = iframeDocument.getElementsByClassName('single-user');

      if (singleUser.length) {
        for (let i = 0; i < singleUser.length; i++) {
          singleUser[i].addEventListener('click', () => navigate(links.singleUser));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="user-management" src={path} width="100%" height="800px" />;
}

export default UserManagement;
